//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Pagination from '@material-ui/lab/Pagination';
import NoData from './NoData';
import { tableStyles, GreenCheckbox } from './style';
// material-ui icons
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

import { useTranslation } from 'react-i18next';

GreenCheckbox((props) => <Checkbox color='default' {...props} />);

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    numSelected,
    rowCount,
    headings,
    sorting,
    sortingFields,
    rowData,
    handleData,
    translation,
  } = props;
  const [sort, setSort] = useState(false);


  // sorting func
  const handleSort = (values) => {
    let row = sortingFields.position;
    let data = [];
    data = rowData;
    if (values.asc) {
      data.sort(function (a, b) {
        return new Date(a[row]) - new Date(b[row]);
      });
    }
    if (values.des) {
      data.sort(function (a, b) {
        return new Date(b[row]) - new Date(a[row]);
      });
    }
    return handleData(data);
  };

  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        {props.checkbox && (
          <TableCell padding='checkbox'>
            <GreenCheckbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all desserts' }}
            />
          </TableCell>
        )}
        {sorting
          ? headings?.map((h, i) => (
              <TableCell key={i} className={classes.tableHeading}>
                {sortingFields.column == h ? (
                  <React.Fragment>
                    {h}&nbsp;
                    {sort ? (
                      <ArrowDownwardIcon
                        className={classes.arrowIcon}
                        onClick={() => {
                          setSort(false);
                          handleSort({ des: true });
                        }}
                      />
                    ) : (
                      <ArrowUpwardIcon
                        className={classes.arrowIcon}
                        onClick={() => {
                          setSort(true);
                          handleSort({ asc: true });
                        }}
                      />
                    )}
                  </React.Fragment>
                ) : (
                  h
                )}
              </TableCell>
            ))
          : headings?.map((h, i) => (
              <TableCell key={i} className={classes.tableHeading}>
                {h?.type == 'div' || typeof h == 'object' ? h : translation(h)}
              </TableCell>
            ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default function EnhancedTable(props) {
  const {
    data,
    handlePagination,
    offset,
    count,
    disablePagination,
    currentTab,
    sorting,
    sortingFields,
  } = props;
  const classes = tableStyles();
  const { t, i18n } = useTranslation();

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [dense, setDense] = React.useState(false);
  const [rowData, setRowData] = React.useState([]);

  useEffect(() => {
    if (data) setRowData(data);
  }, [data]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // select all checkbox func
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = props.data.map((n) => n[1]);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // checkbox func
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleData = (d) => {
    setRowData([...d]);
  };

  return rowData && rowData.length > 0 ? (
    <div className={classes.root}>
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={dense ? 'small' : 'medium'}
          aria-label='enhanced table'
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            headings={props.headings}
            sorting={sorting}
            sortingFields={sortingFields}
            rowData={rowData}
            handleData={handleData}
            checkbox={props.checkbox}
            translation={t}
          />
          <TableBody>
            {rowData &&
              rowData.length > 0 &&
              rowData.map((row, index) => {
                const isItemSelected = isSelected(row[1]);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow hover role='checkbox' tabIndex={-1} key={index}>
                    {props.checkbox && (
                      <TableCell padding='checkbox'>
                        <GreenCheckbox
                          onClick={(event) => handleClick(event, row[1])}
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                    )}
                    {row.map((col, i) => (
                      <React.Fragment key={i}>
                        <TableCell
                          align='left'
                          key={i}
                          className={classes.tabelCell}
                        >
                          {col}
                        </TableCell>
                      </React.Fragment>
                    ))}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {!disablePagination && (
        <Pagination
          className={classes.pagination}
          variant='outlined'
          shape='rounded'
          count={count}
          page={offset}
          siblingCount={1}
          onChange={(event, value) => {
            handlePagination(value);
          }}
        />
      )}     
    </div>
  ) : (
    <NoData currentTab={currentTab} />
  );
}
